module.exports = __webpack_public_path__ + "img/dept-11.1c9bbea0.svg";